import { render } from "./ListingPhotos.vue?vue&type=template&id=4c805ffc"
import script from "./ListingPhotos.vue?vue&type=script&lang=js"
export * from "./ListingPhotos.vue?vue&type=script&lang=js"

import "./ListingPhotos.vue?vue&type=style&index=0&id=4c805ffc&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__